import type { VoidFunctionComponent } from 'react';

import useDeleteApiWebhookSetting from '../../../../hooks/api/settings/integrations/useDeleteApiWebhookSetting';
import { BUTTON_SIZE, FormGroup, LabeledTextInput } from '../../../generic';
import { LoaderButton } from '../../../generic/Button';
import type { NotificationWebhookResponse } from '../../../../../shared/settings/apiWebhooks';

type Props = {
  webhook: NotificationWebhookResponse,
};

const ApiWebhookRow: VoidFunctionComponent<Props> = ({
  webhook,
}) => {
  const { mutate: deleteWebhook, isLoading } = useDeleteApiWebhookSetting(webhook.id);
  return (
    <FormGroup direction="row" spacing="xl" baselineAlignment>
      <LabeledTextInput
        label="Webhook URL"
        value={webhook.endpoint || ''}
        isDisabled
      />
      <LoaderButton
        type="error"
        isLoading={isLoading}
        size={BUTTON_SIZE.MEDIUM}
        onClick={() => deleteWebhook()}
      >
        Remove
      </LoaderButton>
    </FormGroup>
  );
};

export default ApiWebhookRow;
